const actions = {
  fetchLocations: function ({commit, dispatch}, filters) {
    dispatch('locationsCollisions/fetch', filters.selectedLocationIds, {root: true})
  },

  setFilters: function ({dispatch, rootState}) {
    dispatch('filterLocations/setSelectedLocations', rootState.route.params.lids, {root: true})
    dispatch('filterLocations/setSelectedLocationIds', rootState.route.params.lids, {root: true})
  },

  resetResults: function ({dispatch}) {
    dispatch('locationsCollisions/reset', null, {root: true})
  }
}

const getters = {
  filters (state, getters, rootState, rootGetters) {
    return {
      selectedLocations: rootGetters['filterLocations/selectedLocations'],
      selectedLocationIds: rootGetters['filterLocations/selectedLocationIds']
    }
  }
}

export const LocationsView = {
  namespaced: true,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/views/LocationsView.js